import React, { useState } from 'react';
import { FaChevronRight, FaEye, FaTrashAlt } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { deleteLead, getEmployees, getLead, getLeadbyid } from '../../Actions/actions';
import { useSelector } from 'react-redux';
import { LeadDetailsModal } from '../../screens/LeadMangement/LeadManagementScreen';
import { useDispatch } from 'react-redux';
import ConfirmDeleteModal from '../ConfirmDeleteModal/ConfirmDeleteModal';

const AssignLeadComponent = ({ viewall, need, heading, travelData, handleDownloadCSV, dropdownOptions, selectedOption, handleOptionChange }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { loginData, leadsData, loader } = useSelector(
        (state) => state.userReducer
    );
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);
    const [deleteid, setdeleteid] = useState("");
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const getLeaddata = () => {
        dispatch(getLead(loginData?.accessToken));
    }; const handleDelete = (id) => {
        setdeleteid(id);
        setIsDeleteModalOpen(true);
    };
    const handleEdit = (lead) => {
        dispatch(getLeadbyid(loginData?.accessToken, lead.id));
        dispatch(getEmployees(loginData?.accessToken, true));
        setIsDetailModalOpen(true);
    };
    const confirmDelete = () => {
        dispatch(
            deleteLead(loginData?.accessToken, deleteid, () => {
                getLeaddata();
                setIsDeleteModalOpen(false);
            })
        );
    };
    return (
        <div className="min-w-full container mx-auto bg-white shadow-md rounded-lg">
            <div className="bg-white rounded-t-lg p-4 flex md:flex-row sm:flex-col space-y-4 sm:space-y-0 sm:space-x-0 md:space-x-6 items-center self-center">
                <div className="relative md:w-4/6 sm:w-full mb-[15px] md:mb-0">
                    <h2 className="text-xl font-semibold  text-left">{heading}</h2>
                </div>
                {need ?
                    <div className="md:mt-0 md:w-3/6 sm:w-full flex sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0">
                        <select
                            value={selectedOption}
                            onChange={handleOptionChange}
                            className="border border-gray-300 rounded-lg px-4 py-2 w-full sm:w-3/6"
                        >
                            <option value="">Select days</option>
                            {dropdownOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>

                        <button
                            onClick={handleDownloadCSV}
                            className="p-2 bg-gray-200 rounded-md flex items-center space-x-1 w-full sm:w-3/6 justify-center"
                        >
                            <span>Download CSV</span>
                            <FiDownload className="w-4 h-4" />
                        </button>
                    </div>
                    : null}
            </div>
            <div className="overflow-x-auto bg-white rounded-b-lg">
                <table className="min-w-full overflow-hidden">
                    <thead className="bg-gray-100">
                        <tr className="bg-gray-100 text-left">
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[150px]">Lead Name</th>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[150px]">Email</th>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[150px]">Phone Number</th>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[120px]" >Sales Rep</th>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[120px]">Stage</th>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[120px]">Lead Source</th>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 min-w-[120px]">Status</th>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-600">Action</th>

                        </tr>
                    </thead>
                    <tbody className="text-sm text-gray-800">
                        {travelData.length > 0 && viewall ?
                            travelData.slice(0,3).map((row, idx) => (
                                <tr key={idx} className="border-b last:border-none">
                                    <td className="p-4 text-gray-800">{row.leadName}</td>
                                    <td className="p-4 text-gray-800">{row.email}</td>
                                    <td className="p-4 text-gray-800">{row.phoneNumber}</td>
                                    <td className="p-4 text-gray-800">{row.salesRep} km</td>
                                    <td className="p-4 text-gray-800">{row.stage} mins</td>
                                    <td className="p-4 text-gray-800">{row.leadSource}</td>
                                    <td className="p-4 text-gray-800">{row.status}</td>
                                    <td className="px-4 py-3 flex space-x-2">
                                        <button
                                            onClick={() => {
                                                handleEdit(row);
                                            }}
                                            className="text-gray-600 hover:text-blue-500 bg-gray-100 p-2 rounded-full" >
                                            <FaEye />
                                        </button>
                                        <button
                                            onClick={() => handleDelete(row.id)}

                                            className="text-gray-600 hover:text-red-500 bg-gray-100 p-2 rounded-full" >
                                            <FaTrashAlt />
                                        </button>
                                    </td>
                                </tr>
                            )) : travelData.map((row, idx) => (
                                <tr key={idx} className="border-b last:border-none">
                                    <td className="p-4 text-gray-800">{row.leadName}</td>
                                    <td className="p-4 text-gray-800">{row.email}</td>
                                    <td className="p-4 text-gray-800">{row.phoneNumber}</td>
                                    <td className="p-4 text-gray-800">{row.salesRep} km</td>
                                    <td className="p-4 text-gray-800">{row.stage} mins</td>
                                    <td className="p-4 text-gray-800">{row.leadSource}</td>
                                    <td className="p-4 text-gray-800">{row.status}</td>
                                    <td className="px-4 py-3 flex space-x-2">
                                        <button
                                            onClick={() => {
                                                handleEdit(row);
                                            }}
                                            className="text-gray-600 hover:text-blue-500 bg-gray-100 p-2 rounded-full" >
                                            <FaEye />
                                        </button>
                                        <button
                                            onClick={() => handleDelete(row.id)}

                                            className="text-gray-600 hover:text-red-500 bg-gray-100 p-2 rounded-full" >
                                            <FaTrashAlt />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
            {travelData.length == 0 ?
                <p className="p-4 text-gray-800 text-center">No any assigned lead found</p>
                : null
            }
            {viewall ?
                <div className="p-4 py-6 flex justify-end">
                    <p onClick={() => {
                        navigate('/assign-leads', {
                            state: { travelData: travelData },
                        });

                    }} className="text-sm text-black flex items-center cursor-pointer">
                        View All <FaChevronRight className="ml-1" />
                    </p>
                </div>
                :
                <div className=" pb-2">
                </div>
            }
            <LeadDetailsModal
                isOpen={isDetailModalOpen}
                onClose={() => setIsDetailModalOpen(false)}
                leadData={selectedLead}
                onConfirm={() => {
                    getLeaddata();
                }}
            />
            <ConfirmDeleteModal
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
                onConfirm={confirmDelete}
            />
        </div>
    );
};

export default AssignLeadComponent;
